// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"627943c0","488":"261d7ab8","667":"f849e4f9"}[chunkId] + ".chunk.js";
};